var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('a',{staticClass:"whatsapp-button",class:{'mobile': _vm.isMobile},attrs:{"id":"wh-widget-send-button","href":("https://wa.me/" + _vm.WHATSAPP_NUMBER),"target":"_blank"}},[_c('i',{staticClass:"fa fa-whatsapp"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }